import { io } from 'socket.io-client';

// Get socket configuration from environment variables
const socketUrl = process.env.REACT_APP_SOCKET_URL;

// Define socket options with better reliability settings
const socketOptions = {
  reconnectionDelayMax: parseInt(process.env.REACT_APP_SOCKET_RECONNECTION_DELAY_MAX) || 5000,
  reconnectionAttempts: parseInt(process.env.REACT_APP_SOCKET_RECONNECTION_ATTEMPTS) || 10,
  timeout: parseInt(process.env.REACT_APP_SOCKET_TIMEOUT) || 20000,
  transports: ['websocket', 'polling'],
  withCredentials: true,
  autoConnect: true,
  forceNew: false
};

// Create a single socket instance that can be imported across components
const socket = io(socketUrl, socketOptions);

// Log socket lifecycle events
socket.on('connect', () => {
  console.log('Socket connected with ID:', socket.id);
});

socket.on('disconnect', (reason) => {
  console.log('Socket disconnected. Reason:', reason);
  
  // Automatically reconnect unless explicitly disconnected
  if (reason === 'io server disconnect') {
    console.log('Disconnected by server. Attempting to reconnect...');
    socket.connect();
  }
});

socket.on('connect_error', (error) => {
  console.error('Socket connection error:', error.message);
});

// Add connection debugging
socket.on('reconnect_attempt', (attempt) => {
  console.log(`Socket reconnection attempt: ${attempt}`);
});

socket.on('reconnect', (attempt) => {
  console.log(`Socket reconnected after ${attempt} attempts`);
});

socket.on('reconnect_error', (error) => {
  console.error('Socket reconnection error:', error);
});

socket.on('error', (error) => {
  console.error('Socket error:', error);
});

// Ping the server to help keep the connection alive
setInterval(() => {
  if (socket.connected) {
    socket.emit('ping_server');
  }
}, 30000);

// Force reconnection if needed
if (!socket.connected) {
  console.log('Socket not connected on initialization, connecting...');
  socket.connect();
}

export { socket }; 